import {useId} from 'react'
import {Card, Radio, theme} from 'antd'
import {t} from '@lingui/core/macro'
import styles from './PaymentPlatformSelector.module.css'

const PaymentPlatformSelector = ({options = [], value, onChange}) => {
    const name = useId()
    const {token} = theme.useToken()
    return <Card size="small" styles={{body: {padding: 0}}} style={{borderRadius: 12}}>
        <Radio.Group name={name} value={value} onChange={event => onChange?.(event.target.value)}
            aria-label={t`Moyen de paiement`} className={styles.group} style={{
                '--selector-border': `var(--line, ${token.colorBorderSecondary})`,
                '--selector-brand': `var(--primary, ${token.colorPrimary})`,
                '--selector-padding': `${token.padding}px`,
                '--selector-gap': `${token.marginSM}px`,
            }}>
            {options.map(option => <Radio key={option.value} value={option.value} disabled={option.disabled}
                className={`${styles.option} ${value === option.value ? styles.selected : ''}`}>
                <span className={styles.label}>
                    {option.image && <span className={styles.imageSlot} aria-hidden="true">
                        <img src={`/img/payment-platforms/${option.image}`} alt="" className={`${styles.image} ${styles[option.imageVariant] || ''}`} />
                    </span>}
                    <span>{option.label}</span>
                </span>
            </Radio>)}
        </Radio.Group>
    </Card>
}

export default PaymentPlatformSelector
